// Money formatting helpers — single source of truth so every screen renders
// balances and transactions identically.
//
// Conventions (per ops feedback):
//   * Balance      → rounded to the whole dollar, $XXX,XXX,XXX (no cents)
//   * Transaction  → exact, $XXX,XXX,XXX.xx (two decimals)
//
// `null`/`undefined` render as an em-dash so column widths don't jump.

const balanceFmt = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const transactionFmt = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatBalance(amount: number | null | undefined): string {
  if (amount === null || amount === undefined || Number.isNaN(amount)) return '—';
  return balanceFmt.format(Math.round(amount));
}

export function formatTransaction(amount: number | null | undefined): string {
  if (amount === null || amount === undefined || Number.isNaN(amount)) return '—';
  return transactionFmt.format(amount);
}
